export default "__VITE_ASSET__G1yYU1AJ__"